//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import Components
import {Button, Row, Col, Form, FormGroup, Label, Input} from 'reactstrap'

import ImageSelector from '../../ImageSelector/ImageSelector';
import EditConfirmButton from '../../EditConfirmButton/EditConfirmButton';
import UpDownButton from '../../UpDownButton/UpDownButton';

//import Styles

class DepartmentNormalFormLine extends Component {

    render(){
        const {koName, koContent, enName, enContent, index} = this.props;
        const {editing} = this.props;
        return (
            <div>
                <Row>
                    <Col>
                        <ImageSelector 
                            storagePath={this.props.storagePath}
                            imageId={this.props.data.id}
                        />
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">제목</Label>
                                <Input
                                    type="text"
                                    name="koName"
                                    value={koName}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">내용</Label>
                                <Input
                                    type="textarea"
                                    name="koContent"
                                    value={koContent}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">Title</Label>
                                <Input
                                    type="text"
                                    name="enName"
                                    value={enName}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">Content</Label>
                                <Input
                                    type="textarea"
                                    name="enContent"
                                    value={enContent}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col sm={1}>
                        <UpDownButton
                            disabled={this.props.editAnything}
                            onOrderUp={() => {
                                this.props.onDataOrderSwitch(this.props.dbPath, index, index - 1);
                            }}
                            onOrderDown={() => {
                                this.props.onDataOrderSwitch(this.props.dbPath, index, index + 1);
                            }}
                        />
                        <EditConfirmButton 
                            editing={editing}
                            onConfirm={ () => {
                                this.props.onUpdate(
                                    this.props.dbPath,
                                    this.props.data.id, {
                                        type : this.props.type,
                                        name :  {
                                            en : enName,
                                            ko : koName
                                        },
                                        content : {
                                            en: enContent,
                                            ko: koContent
                                        },
                                        promotion: this.props.promotion
                                    })
                            }}
                            onToggleEditing={() => {
                                this.props.onToggleEditing()
                            }}
                            onRemove={() => {
                                this.props.onRemove(this.props.dbPath, 
                                                    this.props.storagePath, {
                                                        id : this.props.data.id 
                                                    })
                            }}
                        />
                    </Col>
                </Row>

            </div>
        );
    }
}

export default DepartmentNormalFormLine;

DepartmentNormalFormLine.propTypes = {
    data : PropTypes.object.isRequired,
    onUpdate : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired,
    storagePath : PropTypes.string.isRequired,
}

DepartmentNormalFormLine.defaultProps = {
    onUpdate : null,
    onRemove : null,
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/FormLines/DepartmentNormalFormLine.js